import { el } from "./dom";

/** Custom, non-blocking toasts. We never use native alert()/confirm(). */
export type ToastKind = "info" | "success" | "warning" | "error";

let container: HTMLElement | null = null;

function getContainer(): HTMLElement {
  if (!container) {
    container = el("div", { class: "toasts", "aria-live": "polite" });
    document.body.append(container);
  }
  return container;
}

export function toast(
  message: string,
  kind: ToastKind = "info",
  timeoutMs = 5000
): void {
  const root = getContainer();
  const item = el(
    "div",
    { class: `toast toast-${kind}`, role: "status" },
    el("span", { class: "toast-msg", text: message }), // text => no markup injection
    el(
      "button",
      { class: "toast-close", "aria-label": "Dismiss", onclick: dismiss },
      "\u00d7"
    )
  );
  function dismiss(): void {
    item.classList.add("toast-out");
    setTimeout(() => item.remove(), 180);
  }
  root.append(item);
  if (timeoutMs > 0) setTimeout(dismiss, timeoutMs);
}
